import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { select, Store } from '@ngrx/store';
import { getInsightsId } from '@planone/bau365/data-access-fair-data';
import { catchError, forkJoin, map, of, switchMap, withLatestFrom } from 'rxjs';

import {
  loadQuicklinks,
  loadQuicklinksFailure,
  loadQuicklinksSuccess,
  loadTopTagsFailure,
  loadTopTagsSuccess,
} from './newsfeed-quicklinks.actions';

import { NewsfeedService } from '../../service/data-access-newsfeed.service';

@Injectable()
export class NewsfeedQuicklinksEffects {
  private actions$ = inject(Actions);

  loadTopTags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadQuicklinks),
      withLatestFrom(this.store.pipe(select(getInsightsId))),
      switchMap(([_, insightsId]) =>
        this.newsfeedService.getTopTags(insightsId).pipe(
          map(({ topTags }) => loadTopTagsSuccess({ topTags })),
          catchError((error) => {
            return of(loadTopTagsFailure({ error }));
          })
        )
      )
    )
  );

  loadQuicklinks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTopTagsSuccess),
      withLatestFrom(this.store.pipe(select(getInsightsId))),
      switchMap(([{ topTags }, insightsId]) =>
        forkJoin(topTags.map((topTag) => this.newsfeedService.getQuicklink(topTag, insightsId))).pipe(
          map((quicklinks) => quicklinks.filter((quicklink) => !!quicklink)),
          map((quicklinks) => loadQuicklinksSuccess({ quicklinks })),
          catchError((error) => {
            return of(loadQuicklinksFailure({ error }));
          })
        )
      )
    )
  );

  constructor(private readonly newsfeedService: NewsfeedService, private store: Store) {}
}
